import { InjectionToken } from '@angular/core';

/**
 * Injection token for the default `accept` attribute used by
 * {@link ShFileInputComponent}. Each application can provide its own value
 * (e.g. a tenant-specific allow-list of MIME types/extensions) at the root
 * provider level so individual components don't have to wire it up manually.
 */
export const FILE_INPUT_ACCEPTED_TYPES = new InjectionToken<string>('FILE_INPUT_ACCEPTED_TYPES', {
    providedIn: 'root',
    factory: () => '*/*'
});

/**
 * Status of a locally selected file in {@link ShFileInputComponent}. Use the
 * enum values instead of repeating string literals across the codebase.
 */
export const FileUploadStatus = {
    Pending: 'pending',
    Uploading: 'uploading',
    Success: 'success',
    Error: 'error'
} as const;

export type FileUploadStatus = (typeof FileUploadStatus)[keyof typeof FileUploadStatus];
